import { ROUTES } from '../lib/route';

/**
 * The last card in the stack (DESIGN.md §7, "The last card").
 *
 * "A different treatment — corkboard texture, pushpin, no marquee frame — that
 * leads to the Pitch Room. It reads as pinned to the wall below the board
 * rather than as another screening, which is the point: it is the one card that
 * isn't a thing you can turn up to."
 *
 * So this is deliberately the only card on the board that does **not** wear the
 * bulb frame, and the only one with no time on it. Everything above it answers
 * "what is playing and when"; this one answers "and what about what I want".
 *
 * It is also the board's empty state's companion: §16a asks for "the corkboard
 * of pending pitches surfaced right there" on a quiet week, and a board with
 * nothing on it is exactly when somebody should be pitching something.
 *
 * An `<a>` rather than a button since the room became a page: it goes
 * somewhere, so middle-click and open-in-new-tab should work, and the browser
 * should show the URL on hover like it does for every other link.
 */

export function PitchCallCard({
  /** A wildcard slot is open and still taking votes. Changes what this is for. */
  voting,
}: {
  voting: boolean;
}) {
  return (
    <a className="pitch-call" href={ROUTES.pitch}>
      <span className="pitch-call__pin" aria-hidden="true" />
      <span className="pitch-call__body">
        <span className="pitch-call__title">Predloži film</span>
        <span className="pitch-call__sub">
          {voting
            ? 'Glasanje je u toku. Cedulja sa najviše glasova dobija termin.'
            : 'Zakači ceduljicu. Stoji na tabli dok ne dobije termin.'}
        </span>
      </span>
    </a>
  );
}
